<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">职位JD<el-button class="ml10" type="text" @click="toEdit">编辑</el-button></h3>
    <div class="card-content">
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('岗位要求') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          岗位描述和岗位要求：
        </div>
        <pre>{{ project.岗位描述和岗位要求 || '暂无岗位描述和岗位要求' }}</pre>
      </div>
      <!-- <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('岗位要求') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          岗位要求（0.5%<el-tooltip
            class="item"
            style="display:inline;color:#409EFF"
            effect="dark"
            content="业绩贡献率"
            placement="top"
            ><i class="el-icon-question"></i></el-tooltip
          >）：
        </div>
        <pre>{{ project.岗位要求 || '暂无岗位要求' }}</pre>
      </div> -->
      <!-- <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('岗位职责') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          岗位职责（0.5%<el-tooltip
            class="item"
            style="display:inline;color:#409EFF"
            effect="dark"
            content="业绩贡献率"
            placement="top"
            ><i class="el-icon-question"></i></el-tooltip
          >）：
        </div>
        <pre>{{ project.岗位职责 || '暂无岗位职责' }}</pre>
      </div> -->
      <!-- <div class="project-detail-content">
        <div :class="[hasNotValueFields.includes('岗位薪酬') ? 'warning-text' : '', 'project-detail-content-title mb10']">岗位薪酬（1%<el-tooltip class="item" style="display:inline;color:#409EFF" effect="dark" content="业绩贡献率" placement="top"><i class="el-icon-question"></i></el-tooltip>）：</div>
        <pre>{{ project.岗位薪酬 || '暂无岗位薪酬' }}</pre>
      </div>
      <div class="project-detail-content">
        <div :class="[hasNotValueFields.includes('关键面试人') ? 'warning-text' : '', 'project-detail-content-title mb10']">关键面试决策人：</div>
        <div class="flex flex-wrap">
          <div v-for="(item, index) in interviewer" :key="`interviewer${index}`" class="hr-card mr10 mb5">
            <div class="half-box">
              <span class="name text-btn" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
              <div class="job-box">
                <p>{{ item.目前职位 }}</p>
                <p>{{ item.职级 }}</p>
              </div>
            </div>
            <div class="half-box">
              <p class="tel">{{ item.手机 }}</p>
              <p class="gray">{{ item.座机 }}</p>
              <p class="gray">{{ item.邮箱 }}</p>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <el-dialog
      :visible.sync="isEditing"
      custom-class="custom-dialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div slot="title" class="title">
        <div class="title-name">职位JD</div>
        <div class="side-title"></div>
        <!-- <div class="handle-btn">
          <el-button size="mini" type="text" @click="openHistory('项目基本信息')">操作记录</el-button>
        </div> -->
      </div>
      <div class="card-content">
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('岗位描述和岗位要求') ? 'warning-text' : '', 'field-label']">
            岗位描述和岗位要求
          </span>
          <el-input
            v-model="projectInEdit.岗位描述和岗位要求"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该岗位的具体要求"
          ></el-input>
        </div>
        <!-- <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('岗位要求') ? 'warning-text' : '', 'field-label']"
            >岗位要求（0.5%<el-tooltip
              class="item"
              style="display:inline;color:#409EFF"
              effect="dark"
              content="业绩贡献率"
              placement="top"
              ><i class="el-icon-question"></i></el-tooltip
            >）
          </span>
          <el-input
            v-model="projectInEdit.岗位要求"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该岗位的具体要求"
          ></el-input>
        </div> -->
        <!-- <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('岗位职责') ? 'warning-text' : '', 'field-label']"
            >岗位职责（0.5%<el-tooltip
              class="item"
              style="display:inline;color:#409EFF"
              effect="dark"
              content="业绩贡献率"
              placement="top"
              ><i class="el-icon-question"></i></el-tooltip
            >）
          </span>
          <el-input
            v-model="projectInEdit.岗位职责"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该岗位的具体职责"
          ></el-input>
        </div> -->
        <!-- <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('岗位薪酬') ? 'warning-text' : '', 'field-label']">岗位薪酬（1%<el-tooltip class="item" style="display:inline;color:#409EFF" effect="dark" content="业绩贡献率" placement="top"><i class="el-icon-question"></i></el-tooltip>） </span>
          <el-input
            v-model="projectInEdit.岗位薪酬"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该岗位的薪酬情况"
          ></el-input>
        </div>
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('关键面试决策人') ? 'warning-text' : '', 'field-label']">关键面试决策人（1%<el-tooltip class="item" style="display:inline;color:#409EFF" effect="dark" content="业绩贡献率" placement="top"><i class="el-icon-question"></i></el-tooltip>）
            <el-popover
              v-if="company._id"
              v-model="companyInterviewerVisible"
              placement="right"
              width="800"
              trigger="click"
            >
              <div class="propject_detail_info_table col-1" style="max-height:70vh;font-size:14px;padding:10px">
                <p style="text-align:center;margin-bottom:20px" class="flex-row">
                  <el-input v-model="temporaryInterviewerKeyword" size="mini" placeholder="输入姓名进行搜索"></el-input>
                  <el-button size="mini" type="primary" @click="getTemporaryInterviewers(temporaryInterviewerKeyword)"
                    >搜索</el-button
                  >
                </p>
                <p class="mb10" style="color:#409EFF">点击选择一位关键面试决策人(可多选)</p>
                <div v-if="interviewerLoading" class="loading-mask"><i class="el-icon-loading"></i></div>
                <div v-else>
                  <div class="flex-row project_table_thead item-center">
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">公司</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">部门</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职能模块</span>
                  </div>
                  <div
                    v-for="(value, i) in temporaryInterviewer"
                    :key="`companyHr${i}`"
                    :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                    @click="chooseInterviewer(value)"
                  >
                    <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['公司'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['部门'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">
                      <el-tag v-for="item in value['职能模块']" :key="item" size="mini" type="primary">{{ item }}</el-tag>
                    </span>
                  </div>
                </div>
              </div>
              <i slot="reference" class="el-icon-circle-plus text-btn mb10" style="font-size:16px;"/>
            </el-popover>
          </span>
          <div class="flex flex-wrap">
            <div v-for="(item, index) in tempInterviewer" :key="`interviewer${index}`" class="hr-card mr10 mb5">
              <span class="close" @click="removeInterviewer(item)">X</span>
              <div class="half-box">
                <span class="name text-btn" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
                <div class="job-box">
                  <p>{{ item.目前职位 }}</p>
                  <p>{{ item.职级 }}</p>
                </div>
              </div>
              <div class="half-box">
                <p class="tel">{{ item.手机 }}</p>
                <p class="gray">{{ item.座机 }}</p>
                <p class="gray">{{ item.邮箱 }}</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div slot="footer">
        <el-row type="flex" align="center" justify="center">
          <el-button size="small" type="info" style="margin-right:20px" @click="cancelEdit">取消</el-button>
          <el-button size="small" type="primary" class="custom-primary-plain" @click="confirmEdit">保存</el-button>
        </el-row>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import { defaultProject, defaultCompany } from '../../constant/defaultData'
import mixin from './mixin'

export default {
  mixins: [mixin],
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
    hasNotValueFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      companyInterviewerVisible: false,
      temporaryInterviewerKeyword: '',
      interviewerLoading: false,
      temporaryInterviewer: [],
      interviewer: [],
      tempInterviewer: [],
      componentType: '职位JD',
      fields: [
        '岗位描述和岗位要求',
        // '岗位要求',
        // '岗位职责',
        // '岗位薪酬', '关键面试人'
      ],
    }
  },
  watch: {
    companyInterviewerVisible(val) {
      if (val) {
        this.getTemporaryInterviewers()
      }
    },
  },
  mounted() {
    this.$watch(
      function() {
        // 第一个函数就是处理你要监听的属性，只要将其return出去就行
        return this.project.职能模块
      },
      function(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.getInterviewer()
        }
      },
    )
  },
  methods: {
    toEdit() {
      this.projectInEdit = {}
      this.fields.forEach(key => {
        const value =
          this.project[key] || (typeof defaultProject[key] === 'object' ? window._.cloneDeep(defaultProject[key]) : '')
        if (value && typeof value === 'object') {
          const newVal = JSON.parse(JSON.stringify(value))
          this.$set(this.projectInEdit, key, newVal)
        } else {
          this.$set(this.projectInEdit, key, value)
        }
      })
      this.tempInterviewer = window._.cloneDeep(this.interviewer || [])
      this.isEditing = true
      this.$emit('toEdit', this.componentType)
    },
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    async getInterviewer() {
      const ids = this.project['关键面试人']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.interviewer = res.data
      } else this.interviewer = []
    },
    async getTempInterviewer() {
      const ids = this.projectInEdit['关键面试人']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.tempInterviewer = res.data
      } else this.tempInterviewer = []
    },
    chooseInterviewer(radish) {
      if (!this.projectInEdit['关键面试人']) this.$set(this.projectInEdit, '关键面试人', [])
      if (!this.projectInEdit['关键面试人'].includes(radish._id)) this.projectInEdit['关键面试人'].push(radish._id)
      this.$message({ type: 'success', message: `添加成功` })
      this.getTempInterviewer()
      this.companyInterviewerVisible = false
    },
    removeInterviewer(radish) {
      const index = this.tempInterviewer.findIndex(_hrid => _hrid._id === radish._id)
      const idIndex = this.projectInEdit['关键面试人'].findIndex(_hrid => _hrid === radish._id)
      if (index === -1) return
      this.projectInEdit['关键面试人'].splice(idIndex, 1)
      this.tempInterviewer.splice(index, 1)
    },
    async getTemporaryInterviewers(name) {
      this.interviewerLoading = true
      const postData = {
        type: '人选',
        keywords: '',
        and: false,
        query: {},
        $page: 1,
        $limit: 300,
        $sort: {
          公司排名: 1,
          公司: -1,
          部门: -1,
          职级: 1,
          createdAt: -1,
        },
        fields: [
          '简介',
          '沟通日志',
          '旧系统沟通备注',
          '职能模块',
          '细分职能',
          '个性标签',
          '擅长方向',
          '行业',
          '部门',
          '组别',
          '目前职位',
          '姓名^5',
          '英文名',
          '地域',
          '平台',
          '职级',
          '业绩',
          '性别',
          '婚育',
          '籍贯',
          '公司^5',
          '曾任职公司',
          '管理职级',
          '专业职级',
          '学历',
          '学历标签',
          '语言标签',
          '职业资格',
          '香港牌照',
          '投资风格',
          '*院校',
        ],
      }
      if (name) {
        postData.query = { 公司: this.project['客户公司'], 姓名: name }
        const {
          data: { data },
        } = await app.service('radish').listEs(postData)
        this.temporaryInterviewer = data
        this.temporaryInterviewerKeyword = ''
        this.interviewerLoading = false
      } else {
        const res = await app.service('misc').searchEs({
          type: '人选',
          keywords: name,
          fields: ['姓名^5', '拼音', '公司^5', '职能模块', '手机'],
          and: true,
        })
        if (res.status === 'success') {
          this.temporaryInterviewer = res.data
          this.temporaryInterviewerKeyword = ''
          this.interviewerLoading = false
        } else this.$message.error(res.msg)
      }
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
